"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    handleClick: _propTypes.default.func,
    icon: _propTypes.default.string,
    theme: _propTypes.default.string,
    show: _propTypes.default.bool,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    data: _propTypes.default.shape({
      content: _propTypes.default.string.isRequired,
      link: _propTypes.default.string.isRequired
    }),
    background: _propTypes.default.string,
    textColor: _propTypes.default.string,
    linkColor: _propTypes.default.string,
    animation: _propTypes.default.bool,
    iconColor: _propTypes.default.string,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string,
      index: _propTypes.default.string
    })
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    data: _constant2.DEFAULT_DATA,
    accessible: true,
    show: true,
    icon: _constant2.ICON_TYPE,
    animation: false,
    linkColor: _constant2.DEFAULT_STYLE.LINK_COLOR,
    textColor: _constant2.DEFAULT_STYLE.TEXT_COLOR,
    iconColor: _constant2.DEFAULT_STYLE.ICON_COLOR
  }
};
exports.default = _default;